import React from 'react';
import * as Zeego from 'zeego/context-menu';
import { useModalPortalContainer } from '@/data/store/useModalPortalStore';

const ContextMenu = ({ items, children }) => {
    // Portal into the enclosing web modal (if any) so the menu renders above
    // modal overlays — same mechanism as DropdownMenu. Requires the zeego
    // context-menu container passthrough in patches/zeego+3.0.6.patch.
    const modalPortalContainer = useModalPortalContainer();
    if (!items || items.length === 0) return children;

    return (
        <Zeego.Root>
            <Zeego.Trigger>
                {children}
            </Zeego.Trigger>
            <Zeego.Content container={modalPortalContainer ?? null} style={{ zIndex: 10000 }}>
                {items.map((item) => (
                    <Zeego.Item
                        key={item.key}
                        onSelect={item.onSelect}
                        destructive={item.destructive}
                    >
                        {item.icon && (
                            <Zeego.ItemIcon
                                ios={{ name: item.icon.ios, pointSize: 16 }}
                                androidIconName={item.icon.android}
                            />
                        )}
                        <Zeego.ItemTitle>{item.label}</Zeego.ItemTitle>
                    </Zeego.Item>
                ))}
            </Zeego.Content>
        </Zeego.Root>
    );
};

const contextMenuIcons = {
    copy: { ios: 'doc.on.doc', android: 'content_copy' },
    email: { ios: 'envelope', android: 'email' },
    phone: { ios: 'phone', android: 'phone' },
    sms: { ios: 'message', android: 'message' },
    map: { ios: 'map', android: 'map' },
    link: { ios: 'link', android: 'link' },
    share: { ios: 'square.and.arrow.up', android: 'share' },
    edit: { ios: 'pencil', android: 'edit' },
    delete: { ios: 'trash', android: 'delete' },
    person: { ios: 'person', android: 'person' },
};

export default ContextMenu;
export { contextMenuIcons };